module.exports = __webpack_public_path__ + "img/how-to-save-from-extension.f43737e6.svg";